import { createSlice } from "@reduxjs/toolkit";
import { server_url } from "../core/config_geral";

var rpcServidor = localStorage.getItem("rpc_servidor")

if (rpcServidor == null)
    rpcServidor = server_url

var newForm = () => {
    return {
        action: "",
        runNow: true,
        payload: null,
        file: null,
        error: "",
        response: null,
        hide : true,
    }
}

const initialState = {
    servidorUrl: rpcServidor,
    loading: true,
    silentLoading: false,
    resultados: [],
    resultadosPreparados : null,
    calls: [],
    callsFormatted : [],
    buffer: null,
    page: 0,
    form: newForm()
}

export const rpcSlice = createSlice({
    name: "rpc",
    initialState,
    reducers: {
        triggerFirstLoad: () => { },
        setAttr: (state, action) => {
            state[action.payload.campo] = action.payload.valor
        },
        triggerAtualizarDados: () => { },
        triggerAtualizaDadosBuffer : () => {},
        triggerSendRPCCall: () => { },
        setFormAttr: (state, action) => {
            state.form[action.payload.campo] = action.payload.valor
        },
        setServidor: (state, action) => {
            state.servidorUrl = action.payload
            localStorage.setItem("rpc_servidor", action.payload)
        }
    }
})

export const {
    triggerFirstLoad,
    setAttr,
    triggerAtualizarDados,
    triggerAtualizaDadosBuffer,
    triggerSendRPCCall,
    setFormAttr,
    setServidor
} = rpcSlice.actions;

export default rpcSlice.reducer;